<ae-add-edit-template
  [isDialog]="true"
  (closeDialog)="close()"
  [client]="client"
  [project]="project"
  [templateId]="templateId"
>
</ae-add-edit-template>
